/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { checkAndupdateSurveyStatusApi, } from "./../../api/comman/SurveyRedirectApi";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ZAMPLIA_SURVEYS_VENDOR__ID } from "../../config/constants";
import SuccessPopup from "./CompleteSuccessPopup";
import { useAuth } from "context/auth-context";
import { getsurveysPointApi } from "./surveycomplete_api";
import LoadingOverlay from "react-loading-overlay-ts";
import GuestClaimReward from "./guestUserCompleteUi";
import { handleLogout } from "controller/logoutWithUrl";
import { FiShieldOff } from "react-icons/fi";
import { SurveyOutcomeCard } from "./SurveyOutcomeCard";

export const SurveyComplete = () => {
  const { auth, setAuth } = useAuth();
  const [searchParams] = useSearchParams();
  const [uid, setUid] = React.useState("");
  const [sid, setSid] = React.useState("");
  const [vid, setVid] = React.useState("");
  const [sessionId, setSessionId] = React.useState("");
  const [isHmacFailed, SetHmacFailed] = React.useState(false);
  const [hmacValue, setHmacValue] = React.useState("");
  const [currentUrl, setCurrentUrl] = React.useState("");
  const [isShowGuestUserPopUP, setShowGuestUserPopUP] = React.useState<boolean>(false);
  const { t } = useTranslation();
  const [guestLoading, setGueastLoading] = useState(false);
  const [isGuestUser, setIsGuestUser] = useState(2);
  const [surveyPoints, setSurveyPoints] = useState<number>(0);
  const navigate = useNavigate();

  const fetchPoints = async (sessionId: string, rating: number, uid: string) => {
    setGueastLoading(true);
    const response = await getsurveysPointApi(sessionId, rating, uid);

    if (response.success === true) {
      setSurveyPoints(response?.data);
      setIsGuestUser(response?.isGuestUser);
      // Guest survey + logged in user
      if (response?.isGuestUser === 1 && auth?.panelistId) {
        await handleLogout(window.location.href, navigate, setAuth);
        return;
      }
    } else {
      setSurveyPoints(0);
      setIsGuestUser(0);
    }
    setGueastLoading(false);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const uidParam = params.get("UID");
    const sessionIdParam = params.get("SESSION_ID");
    if (sessionIdParam) fetchPoints(sessionIdParam, 0, uidParam);
  }, []);

  useQuery(
    ["checkAndupdateSurveyStatus"],
    () => checkAndupdateSurveyStatusApi(auth?.panelistId || uid, sid, vid, hmacValue, currentUrl, sessionId, "surveyComplete"),
    {
      enabled: !!uid,
      refetchOnWindowFocus: false,
      onSuccess: (response: any) => {
        // eslint-disable-next-line no-prototype-builtins
        if (response && response.hasOwnProperty("isHamcFailed")) {
          if (response.isHamcFailed) {
            SetHmacFailed(true);
          }
        }
      },
    }
  );

  React.useEffect(() => {
    const UID = searchParams.get("UID");
    const SID = searchParams.get("SID");
    const hmac = searchParams.get("hmac");
    const SESSION_ID = searchParams.get("SESSION_ID");
    // getData();

    const VID = ZAMPLIA_SURVEYS_VENDOR__ID;
    if (UID || SID && VID) {
      setUid(UID);
      setSid(SID);
      setVid(VID);
      setSessionId(SESSION_ID);
      const currentFullUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?SID=" +
        SID +
        "&UID=" +
        UID +
        "&SESSION_ID=" +
        SESSION_ID;
      setCurrentUrl(currentFullUrl);
      if (hmac) setHmacValue(hmac);
    }
  }, []);

  const hideGuestUserPopup = () => {
    setShowGuestUserPopUP(false);
  };

  return (
    <LoadingOverlay
      styles={{
        overlay: (base) => ({
          ...base,
          position: "fixed",
        }),
      }}
      active={guestLoading}
      spinner
      text={t("claim.card.Loading")}
    >
      <form className="w-full">
        {isHmacFailed ? (
          <SurveyOutcomeCard
            tone="danger"
            icon={FiShieldOff}
            title={t("page.surveysecurityterminate.internal")}
          />
        ) : (
          <>
            {isGuestUser === 1 ? (
              <GuestClaimReward point={surveyPoints} />
            ) : isGuestUser === 0 ? (
              <SuccessPopup />
            ) : null}
          </>
        )}
      </form>
    </LoadingOverlay>
  );
};
